import { styled } from "@mui/material/styles";
import { Dropdown } from "components/Dropdown";
import { MenuItem } from "@mui/material";
import {
  ChartSubtype,
  ChartSubtypes,
  ChartType
} from "components/DataExplorationV2/ChartSubtypes";

export interface SelectChartSectionProps {
  chartType: ChartType;
  chartSubtype: ChartSubtype;
  onChangeSubtype: (subType: ChartSubtype) => void;
  onChangeChartType: (chartType: ChartType) => void;
}

export const SelectChartSection = ({
  chartType,
  chartSubtype,
  onChangeChartType,
  onChangeSubtype
}: SelectChartSectionProps): JSX.Element => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    onChangeChartType(event.target.value as ChartType);
  };

  return (
    <SectionWrapper>
      <Dropdown
        id="chart-type"
        data-qa="Chart-Type-Dropdown"
        fullWidth
        label="Type"
        size="small"
        value={chartType}
        onChange={handleChange}
        disabled
      >
        <MenuItem value={ChartType.LINE}>Line</MenuItem>
        {/*<MenuItem value={ChartType.SCATTER}>Scatter</MenuItem>*/}
      </Dropdown>
      <ChartSubtypes
        chartSubtype={chartSubtype}
        chartType={chartType}
        onChangeSubtype={onChangeSubtype}
      />
    </SectionWrapper>
  );
};

const SectionWrapper = styled("div")`
  padding: 16px;
`;
